export default "__VITE_ASSET__T2VWoqXx__"